<template>
  <v-dialog v-model="dialog" max-width="800px">
    <div>
      <!--toolbar-->
      <v-toolbar dark color="grey-darken-4" class="elevation-0">
        <v-toolbar-title>{{ $t("repositories.rooms.label") }}</v-toolbar-title>
        <v-spacer />
        <v-btn class="mb-3" variant="outlined" icon color="red" @click="close">
          <v-icon> mdi-close </v-icon>
        </v-btn>
      </v-toolbar>

      <!--CARD-->
      <v-card style="max-height: 80vh; overflow-y: auto">
        <v-row row wrap>
          <v-col xs="12" md="12" lg="12">
            <v-alert
              :model-value="alert"
              type="warning"
              variant="tonal"
              border="bottom"
            >
              {{ $t("repositories.print_alert") }}
            </v-alert>
            <v-list lines="two">
              <v-list-group v-for="(room, r) in repository.rooms" :key="r">
                <template #activator="{ props }">
                  <v-list-item v-bind="props">
                    <v-list-item-content>
                      <v-list-item-title>
                        {{ $t("repositories.rooms.room") }}: {{ room.name }}
                      </v-list-item-title>
                      <v-list-item-subtitle>
                        {{ $t("repositories.rooms.locations") }}:
                        {{ room.locations.length }} —
                        {{ $t("repositories.rooms.shelves") }}:
                        {{ room.shelves_number }}
                      </v-list-item-subtitle>
                    </v-list-item-content>

                    <template #append>
                      <v-btn variant="text" icon @click.stop="getShelves(room)">
                        <v-icon>mdi-format-list-bulleted</v-icon>
                      </v-btn>
                      <v-btn variant="text" icon>
                        <v-icon>mdi-chevron-down</v-icon>
                      </v-btn>
                    </template>
                  </v-list-item>
                </template>

                <!-- Locations -->
                <v-list-item
                  v-for="(location, l) in room.locations"
                  :key="l"
                  :class="l % 2 === 0 ? 'bg-grey-lighten-4' : ''"
                >
                  <v-list-item-content class="ml-4">
                    <v-list-item-title>
                      {{ $t("repositories.table.code") }}: {{ location.code }}
                    </v-list-item-title>
                    <v-list-item-subtitle>
                      {{ $t("repositories.table.position_x") }}:
                      {{ location.position_x }},
                      {{ $t("repositories.table.position_y") }}:
                      {{ location.position_y }}
                    </v-list-item-subtitle>
                    <v-list-item-subtitle>
                      {{ $t("repositories.table.notes") }}:
                      {{ location.notes }}
                    </v-list-item-subtitle>
                  </v-list-item-content>

                  <template #append>
                    <v-btn
                      variant="text"
                      icon
                      @click.stop="getShelves(room, location)"
                    >
                      <v-icon>mdi-format-list-bulleted</v-icon>
                    </v-btn>
                  </template>
                </v-list-item>
              </v-list-group>
            </v-list>
          </v-col>
        </v-row>
      </v-card>
    </div>
  </v-dialog>
</template>

<script>
export default {
  data: () => ({
    dialog: false,
    alert: false,
    repository: {},
  }),
  watch: {
    dialog(value) {
      if (!value) this.close();
    },
  },
  methods: {
    open(repository) {
      this.repository = repository;
      this.dialog = true;
    },
    close() {
      this.dialog = false;
      this.repository = {};
      this.$emit("close");
    },
    getShelves(room, location) {
      if (!location && room.shelves_number > 500) {
        this.alert = true;
        setTimeout(() => {
          this.alert = false;
        }, 2000);
      } else {
        this.$emit("shelves", {
          repositoryId: this.repository._id,
          roomId: room._id,
          locationId: location ? location._id : null,
        });
      }
    },
    showAlert(shelvesNumber) {
      if (shelvesNumber > 500) this.alert = true;
      setTimeout(() => {
        this.alert = false;
      }, 2000);
    },
  },
};
</script>
